import { FC } from 'react';
import PageTemplate from 'components/pageTemplate';
import { VirtualTerminalForm } from './VirtualTerminalForm';
import Animation from 'components/ui/animation';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { Redirect } from 'react-router-dom';

const VirtualTerminal: FC = () => {
  const menuVersion = useSelector(
    (state: RootState) => state.layoutConfiguration.menuVersion
  );
  const isOldMenu = menuVersion === 'old';

  if (isOldMenu) {
    return <Redirect to='/manual-payments/virtual-terminal-form' />;
  }

  return (
    <PageTemplate.Main>
      <PageTemplate.Container>
        <Animation>
          <VirtualTerminalForm />
        </Animation>
      </PageTemplate.Container>
    </PageTemplate.Main>
  );
};

export default VirtualTerminal;
